export default {
    tableModal: state => state.tableModal,
    selectedSection: state => state.selectedSection,
    table: state => state.table,
    finalTable: state => state.finalTable,
    managementToken: state => state.managementToken,
    managementUser: state => state.managementUser,
    itemId: state => state.itemId,
    photosModel: state => state.photosModel,
    profile: state => state.profile,
    algorithm: state => state.algorithm,
};